import type {
  AccountManagementEvent,
  FundsManagementEvent,
  SignupEvent,
} from '@mobi/account/Common/Analytics'
import type { PaymentMethodsAll } from '@mobi/component-library/Areas/Deposit/types'
import { paymentMethodTypeNameMap } from '../Areas/Deposit/Utils/schema'
import type { DepositAnalyticsKeys } from '../Areas/Deposit/typings/types'
import type { WithdrawAnalyticsKeys } from '../Areas/Withdraw/typings/types'

type AnalyticsEventData = {
  accountNumber?: number
  paymentMethod?: PaymentMethodsAll
  [key: string]: unknown
}

export const analyticsKeys = {
  accountManagement: 'account_management',
  signup: 'sign_up_process',
  fundsManagement: 'funds_management',
}

export type EventKey =
  | DepositAnalyticsKeys
  | WithdrawAnalyticsKeys
  | AccountManagementEvent
  | FundsManagementEvent
  | SignupEvent
  | (typeof analyticsKeys)[keyof typeof analyticsKeys]

export type TrackAnalytics = (eventKey: EventKey, data?: AnalyticsEventData) => void

export const track: TrackAnalytics = (eventKey, data = {}) => {
  const { paymentMethod, ...other } = data
  window.dataLayer?.push({
    event: eventKey,
    ...(paymentMethod && { depositMethod: paymentMethodTypeNameMap[paymentMethod] }),
    ...other,
  })
}
